import { render, staticRenderFns } from "./EntryMessageRegister.vue?vue&type=template&id=59eedcec"
import script from "./EntryMessageRegister.vue?vue&type=script&lang=js"
export * from "./EntryMessageRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports